import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.css']
})
export class LoaderComponent implements OnInit {
  @Input('isLoaderVisible') isLoaderVisible: boolean;

  constructor() {
    this.isLoaderVisible = false;
   }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/common/loader/loader.component.ts